/**
 * Button - H5 版本
 * 使用 zarm Button
 */
import React from 'react';
import { Button as ZarmButton } from 'zarm-v3';

export interface IsomorphicButtonProps {
  children?: React.ReactNode;
  className?: string;
  theme?: 'default' | 'primary';
  size?: 'sm' | 'md' | 'lg';
  shape?: 'rect' | 'radius' | 'round';
  block?: boolean;
  onClick?: () => void;
}

export const Button: React.FC<IsomorphicButtonProps> = (props) => (
  <ZarmButton {...props} />
);

export default Button;
